export function Based64(img) {
  return img&&img.base64.replace(
    img.base64.slice(0, img.base64.indexOf(",") + 1),
    ""
  );
}
